import { createContext } from 'react'

import { PropertyResponse } from '../../../apis/fvillage'

export type PropertyContextValue = PropertyResponse

export const PropertyContext = createContext<PropertyContextValue | null>(null)
